import React, { useEffect, useState } from 'react'
import ToggleSwitch from '../../../Components/ToggleSwitch';
import { NetworkManager } from '../../../Components/NetworkManager';
import { default as ReactSelect, components } from "react-select";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import ReactSelectField from '../../../Components/ReactSelectField';
import CreatableReactSelect from '../../../Components/CreatableReactSelect';

const defaultStatus = [{ label: "Pass", value: "Pass" }, { label: "Fail", value: "Fail" }];

const ProcessTypeSpecific = ({processType, onDataChange, isEdit, eData}: any) => {
  const [tyreBrand, setTyreBrand] = useState<any>([]);
  const [tyreSize, setTyreSize] = useState<any>([]);
  const [tyreDepth, setTyreDepth] = useState<any>([]);
  const [selectedTyreBrands, setSelectedTyreBrands] = useState<any>([]);
  const [selectedTyreSizes, setSelectedTyreSizes] = useState<any>([]);
  const [selectedTyreDepth, setSelectedTyreDepth] = useState<any>([]);
  const [tyreCondition, setTyreCondition] = useState<any>([]);
  const [tyreStatus, setTyreStatus] = useState<any>([]);
  const [lightTypes, setLightTypes] = useState<any>([]);
  const [reflectorStatus, setReflectorStatus] = useState<any>([]);
  const [multiStatus, setMultiStatus] = useState<any>([]);
  const [isValid, setIsValid] = useState<any>(false);
  const [toggles, setToggles] = useState<any>({
    isStatusConfirmation: false,
    enableTyreBrands: false,
    enableTyreSizes: false,
    enableTyreDepth: false,
    enableTyreCondition: false,
    selectTyreStatus: false,
    repeatForAllTires: false,
    enableLightTypeCount: false,
    enableLightType: false,
    temperatureValue: false,
    hoursValue: false,
    presetValue: false,
    reflectorRequired: false,
    reflectorCountRequired: false
  });
  const [requiredTyreFields, setRequiredFields] = useState<any>({
    tyreBrandRequired: false,
    tyreSizeRequired: false,
    tyreDepthRequired: false,
    tyreConditionRequired: false,
    tyreStatusRequired: false,
  });
  
  useEffect(() => {
    if (isEdit === "task" && eData) {
      if(["General", "Light", "Reefer", "CTPAT"].includes(eData?.processType)){
        const status = eData?.multiStatus?.map((item: any) => {
            return { label: item, value: item };
          });
        setMultiStatus((prev: any) => (prev !== status ? status || [] : prev));
        if(eData?.processType === "Light"){
          const lightType = eData.lightTypes?.map((item: any) => {
            return {label: item, value: item};
          });
          setLightTypes((prev: any) => (prev !== lightType ? lightType || [] : prev));
          const reflecStatus = eData.reflectorStatus?.map((item: any) => {
            return {label: item, value: item};
          });
          setReflectorStatus((prev: any) => (prev !== reflecStatus ? reflecStatus || [] : prev));
        }
      }else if(eData?.processType === "Tyre" || eData?.processType === "Tire"){
        const brand = eData?.tyreDetails?.tyreBrands?.map((item: any) => {
          return { label: item?.brandName, value: item?.brandId };
        });
        const size = eData?.tyreDetails?.tyreSize?.map((item: any) => {
          return { label: item?.sizeName, value: item?.sizeId };
        });
        const depth = eData?.tyreDetails?.tyredepth?.map((item: any) => {
          return { label: item?.depthName, value: item?.depthId };
        });
        const condition = eData?.tyreDetails?.tyreCondition?.map((item: any) => {
          return { label: item, value: item };
        });
        const status = eData?.tyreDetails?.tyreStatus?.map((item: any) => {
          return { label: item, value: item };
        });
        setSelectedTyreBrands((prev: any) => (prev !== brand ? brand || [] : prev));
        setSelectedTyreSizes((prev: any) => (prev !== size ? size || [] : prev));
        setSelectedTyreDepth((prev: any) => (prev !== depth ? depth || [] : prev));
        setTyreCondition((prev: any) => (prev !== condition ? condition || [] : prev));
        setTyreStatus((prev: any) => (prev !== status ? status || [] : prev));
      }
      setToggles((prevToggles: any) => {
        const newToggles = {
          isStatusConfirmation: eData?.isStatusConfirmation || false,
          enableTyreBrands: eData?.tyreDetails?.tyreBrands !== null || false,
          enableTyreSizes: eData?.tyreDetails?.tyreSize !== null || false,
          enableTyreDepth: eData?.tyreDetails?.tyredepth !== null || false,
          enableTyreCondition: eData?.tyreDetails?.tyreCondition  !== null || false,
          selectTyreStatus: eData?.tyreDetails?.tyreStatus  !== null || false,
          repeatForAllTires: eData?.repeatForAllTires || false,
          enableLightTypeCount: eData?.enableLightTypeCount || false,
          enableLightType: eData?.enableLightType || false,
          temperatureValue: eData?.temperatureValue || false,
          hoursValue: eData?.hoursValue || false,
          presetValue: eData?.presetValue || false,
          reflectorCountRequired: eData?.reflectorCountRequired,
          reflectorRequired: eData?.reflectorRequired,
        };
  
        if (JSON.stringify(prevToggles) === JSON.stringify(newToggles)) {
          return prevToggles;
        }
        return newToggles;
      });
      setRequiredFields((prevReqFields: any)=>{
        const newReqFields = {
          tyreBrandRequired: eData?.tyreDetails?.requiredTyreFields?.tyreBrandRequired,
          tyreSizeRequired: eData?.tyreDetails?.requiredTyreFields?.tyreSizeRequired,
          tyreDepthRequired: eData?.tyreDetails?.requiredTyreFields?.tyreDepthRequired,
          tyreConditionRequired: eData?.tyreDetails?.requiredTyreFields?.tyreConditionRequired,
          tyreStatusRequired: eData?.tyreDetails?.requiredTyreFields?.tyreStatusRequired
        };
  
        if (JSON.stringify(prevReqFields) === JSON.stringify(newReqFields)) {
          return prevReqFields;
        }
        return newReqFields;
      })
    }
  }, [isEdit, eData]);
  
  useEffect(() => {
    let isValid = false;

    if (processType === "Tyre" || processType === "Tire") {
      const tyreValid =
        toggles.enableTyreBrands ||
        toggles.enableTyreSizes ||
        toggles.enableTyreDepth ||
        (toggles.enableTyreCondition && tyreCondition.length > 0) ||
        (toggles.selectTyreStatus && tyreStatus.length > 0);

      isValid = tyreValid;
    }

    if (["General", "Light", "Reefer", "CTPAT"].includes(processType)) {
      isValid = !toggles.isStatusConfirmation || (multiStatus && multiStatus.length > 0);

      if (processType === "Light") {
        isValid = isValid && (!toggles.enableLightType || (lightTypes && lightTypes.length > 0));
        if (toggles.reflectorRequired && !(reflectorStatus && reflectorStatus.length > 0)) {
          isValid = false;
        }
      }
    }
    if (processType === "Picture") {
      isValid = true;
    }
    if (processType === "CTPAT") {
      setToggles((prevToggles: any) => ({
        ...prevToggles,
        isStatusConfirmation: true,
      }));
      setMultiStatus(defaultStatus);
    }

    setIsValid(isValid);

    if (!toggles.isStatusConfirmation && multiStatus.length > 0) {
      setMultiStatus([]);
    }else if (!toggles.enableLightType && lightTypes.length > 0) {
      setLightTypes([]);
    }else if (!toggles.selectTyreStatus && tyreStatus.length > 0) {
      setTyreStatus([]);
    }else if (!toggles.enableTyreCondition && tyreCondition.length > 0) {
      setTyreCondition([]);
    }else if (!toggles.reflectorRequired && reflectorStatus.length > 0) {
      setReflectorStatus([]);
    }
  }, [
    processType,
    toggles.enableTyreBrands,
    toggles.enableTyreSizes,
    toggles.enableTyreDepth,
    toggles.enableTyreCondition,
    toggles.selectTyreStatus,
    tyreCondition,
    tyreStatus,
    toggles.isStatusConfirmation,
    multiStatus,
    toggles.enableLightType,
    lightTypes,
    toggles.reflectorRequired,
    reflectorStatus,
  ]);

  useEffect(()=>{
    if(processType === "Tyre" || processType === "Tire"){
      getAvailableTyreBrands();
      getAvailableTyreSize();
      getAvailableTyreDepth();
      setSelectedTyreBrands([{ label: "All", value: 0 }])
      setSelectedTyreSizes([{ label: "All", value: 0 }])
      setSelectedTyreDepth([{ label: "All", value: 0 }])
    }
  }, [processType])
  
  const getAvailableTyreBrands = () =>{
    let api: string = "api/tyreMasterData/brands";
    NetworkManager.sendJsonRequest(api, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const resData = JSON.parse(dataObj);
        const updatedData = resData.map((item:any) => ({
          label: item.brand,
          value: item.brandId
        }));
        setTyreBrand(updatedData);
      }
    },
    onLoginError)
  };

  const handleRequiredChange = (key: string, value: boolean) => {
    setRequiredFields((prev: any) => ({ ...prev, [key]: value }));
  };

  const getAvailableTyreSize = () =>{
    let api: string = "api/tyreMasterData/sizes";
    NetworkManager.sendJsonRequest(api, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const resData = JSON.parse(dataObj);
        const updatedData = resData.map((item:any) => ({
          label: item.size,
          value: item.tyreSizeId
        }));
        setTyreSize(updatedData);
      }
    },
    onLoginError);
  };
  
  const getAvailableTyreDepth = () =>{
    let api: string = "api/tyreMasterData/depths";
    NetworkManager.sendJsonRequest(api, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const resData = JSON.parse(dataObj);
        const updatedData = resData.map((item:any) => ({
          label: item.tyreDepth,
          value: item.tyreDepthId
        }));
        setTyreDepth(updatedData);
      }
    },
    onLoginError);
  };

  const onLoginError = (err: any) => {
    console.log(err);
  };

  const handleToggleChange = (key: string, value: boolean) => {
    setToggles((prevState:any) => ({
      ...prevState,
      [key]: value,
    }));
  };
  
  useEffect(() => {
    const data = {
      ...toggles,
      ...(toggles.enableTyreBrands && { selectedTyreBrands }),
      ...(toggles.enableTyreSizes && { selectedTyreSizes }),
      ...(toggles.enableTyreDepth && { selectedTyreDepth }),
      ...(toggles.enableTyreCondition && { tyreCondition }),
      ...(toggles.selectTyreStatus && { tyreStatus }),
      ...(toggles.reflectorRequired && { reflectorStatus }),
      lightTypes,
      multiStatus,
      isValid,
      requiredTyreFields,
    };
    
    onDataChange(data);
  }, [requiredTyreFields, reflectorStatus, isValid, toggles, tyreBrand, tyreSize, tyreDepth, selectedTyreBrands, selectedTyreSizes, selectedTyreDepth, tyreCondition, tyreStatus, lightTypes, multiStatus]);


  const handleMultiSelectAll = (selectedOptions: any, type: any) => {
    if (selectedOptions.some((option: any) => option.value !== 0)) {
      selectedOptions = selectedOptions.filter((option: any) => option.value !== 0);
    } else if (selectedOptions.length === 0) {
      selectedOptions = [{ label: "All", value: 0 }];
    }
  
    if(type == "brand"){
      setSelectedTyreBrands(selectedOptions)
    }else if(type == "size"){
      setSelectedTyreSizes(selectedOptions)
    }else if(type == "depth"){
      setSelectedTyreDepth(selectedOptions)
    }
  };

  
  return (
    <div>
        {(processType === "Tyre" || processType === "Tire") && 
        (<>
          <div className='mt-3' style={{border: "1px solid #e0e0e0", borderRadius: "5px", padding: "10px"}}>
            <div className={`row`} style={{height: "12px"}}>{isValid ? <span />: <small className="text-danger fw-700" >Note: Please select at least one option.</small>}</div>
            <div className={`row g-3 align-item-center mt-0`} style={{position:"relative"}} >
              <div className="col-md-4">
                <div className='d-flex justify-content-between pe-2'>
                <ToggleSwitch 
                  label="Select Tire Brand"
                  labelStyle="ms-2 fw-600"
                  checked={toggles.enableTyreBrands}
                  onChange={(value:any) => {handleToggleChange("enableTyreBrands", value)}}/>
                  <div className="d-flex justify-content-center align-items-end">
                    <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreBrandRequired} 
                      onChange={(e) => handleRequiredChange("tyreBrandRequired", e.target.checked)} disabled={!toggles.enableTyreBrands} />
                    <label className='ms-1' htmlFor="Mandatory" style={{display:"inline", fontWeight: "normal", marginBottom: "5px"}}>Mandatory</label>
                  </div>
                  </div>
                <div className={`col-md-12`}>
                  <ReactSelect
                    name="tyreBrands"
                    placeholder={"Select Tire Brand"}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                    options={[{ label: "All", value: 0 }, ...tyreBrand]}
                    value={selectedTyreBrands}
                    onChange={(selected:any) => handleMultiSelectAll(selected, "brand")}
                    isDisabled={!toggles.enableTyreBrands}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className='d-flex justify-content-between pe-2'>
                  <ToggleSwitch 
                    label="Select Tire Sizes"
                    labelStyle="ms-2 fw-600"
                    checked={toggles.enableTyreSizes}
                    onChange={(value:any) => {handleToggleChange("enableTyreSizes", value)}}
                  />
                  <div className="d-flex justify-content-center align-items-end">
                    <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreSizeRequired} 
                      onChange={(e) => handleRequiredChange("tyreSizeRequired", e.target.checked)} disabled={!toggles.enableTyreSizes} />
                    <label className='ms-1' htmlFor="Mandatory" style={{display:"inline", fontWeight: "normal", marginBottom: "5px"}}>Mandatory</label>
                  </div>
                </div>
                <div className={`col-md-12`}>
                <ReactSelect
                  placeholder="Select Tire Sizes"
                  name="tyreSizes"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                  options={[{ label: "All", value: 0 }, ...tyreSize]}
                  value={selectedTyreSizes}
                  onChange={(selected:any) => handleMultiSelectAll(selected, "size")}
                  isDisabled={!toggles.enableTyreSizes}
                />
                </div>
              </div>
              <div className="col-md-4">
              <div className='d-flex justify-content-between pe-2'>
                <ToggleSwitch 
                  label="Select Tire Depth"
                  // labelStyle="ms-2 fw-600"
                  checked={toggles.enableTyreDepth}
                  onChange={(value:any) => {handleToggleChange("enableTyreDepth", value)}}/>
                  <div className="d-flex justify-content-center align-items-end">
                    <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreDepthRequired} 
                      onChange={(e) => handleRequiredChange("tyreDepthRequired", e.target.checked)} disabled={!toggles.enableTyreDepth} />
                    <label className='ms-1' htmlFor="Mandatory" style={{display:"inline", fontWeight: "normal", marginBottom: "5px"}}>Mandatory</label>
                  </div>
                  </div>
                <div className={`col-md-12`}>
                <ReactSelect
                  placeholder="Select Tire Depth"
                  name="tyreDepth"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                  options={[{ label: "All", value: 0 }, ...tyreDepth]}
                  value={selectedTyreDepth}
                  onChange={(selected:any) => handleMultiSelectAll(selected, "depth")}
                  isDisabled={!toggles.enableTyreDepth}
                  />
                </div>
              </div>
            </div>
            <div className={`row g-3 align-item-center mt-0 mb-1`} style={{position:"relative"}} >
              <div className="col-md-6">
              <div className='d-flex justify-content-between pe-2'>
                <ToggleSwitch 
                  label="Select Tire Condition"
                  labelStyle="ms-2 fw-600"
                  checked={toggles.enableTyreCondition}
                  onChange={(value:any) => {handleToggleChange("enableTyreCondition", value)}}/>
                  <div className="d-flex justify-content-center align-items-end">
                    <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreConditionRequired} 
                      onChange={(e) => handleRequiredChange("tyreConditionRequired", e.target.checked)} disabled={!toggles.enableTyreCondition}/>
                    <label className='ms-1' htmlFor="Mandatory" style={{display:"inline", fontWeight: "normal", marginBottom: "5px"}}>Mandatory</label>
                  </div>
                </div>
                <div className={`col-md-12`}>
                  <CreatableSelect
                      isMulti
                      options={[]}
                      name="tyreCondition"
                      value={tyreCondition}
                      onChange={(selected) => setTyreCondition(selected)}
                      placeholder={"Enter tyre condition..."}
                      className="basic-multi-select "
                      classNamePrefix="select"
                      isDisabled={!toggles.enableTyreCondition}
                      styles={{
                        control: (provided:any) => ({
                          ...provided,
                          minHeight: '42px',
                        }),
                      }}
                    />
                    {toggles.enableTyreCondition && <small className="ms-2 fst-italic">Press enter to add new option</small>}
                </div>
              </div>
              <div className="col-md-6">
              <div className='d-flex justify-content-between pe-2'>
                <ToggleSwitch 
                  label="Select Tire Status"
                  labelStyle="ms-2 fw-600"
                  checked={toggles.selectTyreStatus}
                  onChange={(value:any) => {handleToggleChange("selectTyreStatus", value)}}/>
                  <div className="d-flex justify-content-center align-items-end">
                    <input type="checkbox" role="button" className='mb-2' disabled={!toggles.selectTyreStatus} 
                      checked={requiredTyreFields.tyreStatusRequired} onChange={(e) => handleRequiredChange("tyreStatusRequired", e.target.checked)} />
                    <label className='ms-1' htmlFor="Mandatory" style={{display:"inline", fontWeight: "normal", marginBottom: "5px"}}>Mandatory</label>
                  </div>
                </div>
                <div className={`col-md-12`}>
                  <CreatableSelect
                    isMulti
                    options={[]}
                    name="tyreStatus"
                    value={tyreStatus}
                    onChange={(selected) => setTyreStatus(selected)}
                    placeholder={"Enter tyre status..."}
                    className="basic-multi-select "
                    classNamePrefix="select"
                    isDisabled={!toggles.selectTyreStatus}
                    styles={{
                      control: (provided:any) => ({
                        ...provided,
                        minHeight: '42px',
                      }),
                    }}
                  />
                  {toggles.selectTyreStatus && <small className="ms-2 fst-italic">Press enter to add new option</small>}
                </div>
              </div>
            </div>
          </div>
          <div className='row mt-3 d-none'>
            <div className="d-flex">
              <ToggleSwitch 
                label="Repeat steps for all Tires of the Equipment"
                checked={toggles.repeatForAllTires}
                onChange={(value:any) => handleToggleChange("repeatForAllTires", value)}/>
              <a className="ms-1 align-self-center">
                <img 
                className=" pe-auto" 
                src={ "./../images/info.svg"} alt="info" width={18} height={18}
                title="The number of tires will be shown based on the axles configured for the equipment"/>
              </a>
            </div>
          </div>
        </>)}
        {processType === "Reefer" &&
        <div className="row g-3 align-item-center mb-3">
        <div className="col-md-4">
          <ToggleSwitch
            label="Capture Reefer Preset Value"
            labelStyle="ms-2 fw-600"
            checked={toggles.presetValue}
            onChange={(value :any) => handleToggleChange("presetValue", value)} />
        </div>
        <div className="col-md-4">
          <ToggleSwitch
            label="Capture Reefer Hours"
            labelStyle="ms-2 fw-600"
            checked={toggles.hoursValue}
            onChange={(value :any) => handleToggleChange("hoursValue", value)} />
          </div>
          <div className="col-md-4">
          <ToggleSwitch
            label="Capture Reefer Temperature"
            labelStyle="ms-2 fw-600"
            checked={toggles.temperatureValue}
            onChange={(value :any) => handleToggleChange("temperatureValue", value)} />
          </div>
        </div>}
        {(processType !== "Tyre" || processType !== "Tire" || processType !== "Picture") && 
        (<div className="row g-3 align-item-center mt-1 mb-3">
          {processType === "Light" && 
          <div className={`col-md-6`}>
            <ToggleSwitch 
              label="Capture light type"
              labelStyle="ms-2 fw-600"
              checked={toggles.enableLightType}
              onChange={(value:any) => {handleToggleChange("enableLightType", value)}}/>
            <CreatableSelect
              isMulti
              options={[]}
              name="lightTypes"
              value={lightTypes}
              onChange={(selected:any) => setLightTypes(selected)}
              placeholder={"Enter Light Type..."}
              className="basic-multi-select "
              classNamePrefix="select"
              isDisabled={!toggles.enableLightType}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  minHeight: "42px",
                }),
              }}
              
            />
          <div className='mb-1'>{toggles.enableLightType && lightTypes.length === 0 ? (
              <small className="text-danger ms-2 fw-700">light Type is required</small>
            ) : toggles.enableLightType ? (
              <small className="ms-2 fst-italic">Press enter to add new option</small>
            ) : null}</div>
            {/* { toggles.enableLightType && */}
            <ToggleSwitch 
              label="Capture lights count"
              labelStyle="ms-2 fw-600"
              checked={toggles.enableLightTypeCount}
              onChange={(value :any) => handleToggleChange("enableLightTypeCount", value)}
              />
              {/* } */}
          </div>} 
        {["General", "Light", "Reefer", "CTPAT"].includes(processType) && 
          <div className={`col-md-6`}>
            <div className={`col-md-12`}>
              <ToggleSwitch 
                label="Require status confirmation"
                labelStyle="ms-2 fw-600"
                checked={toggles.isStatusConfirmation}
                onChange={(value: any) => handleToggleChange("isStatusConfirmation", value)}
                isDisabled={processType === "CTPAT"}
              />
            </div>
            <div className={`col-md-12 mt-0`}>
              {processType === "CTPAT" ? (
                <Select
                  isMulti
                  options={[...defaultStatus]}
                  name="multiStatus"
                  value={multiStatus}
                  onChange={() => {}}
                  placeholder={"Select multi status..."}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isDisabled={true}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      minHeight: "42px",
                    }),
                  }}
                />
              ) : (
                <CreatableSelect
                  isMulti
                  options={[]}
                  name="multiStatus"
                  value={multiStatus}
                  onChange={(selected) => setMultiStatus(selected)}
                  placeholder={"Enter multi status..."}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isDisabled={!toggles.isStatusConfirmation}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      minHeight: "42px",
                    }),
                  }}
                />
              )}
              {toggles.isStatusConfirmation && multiStatus.length === 0 ? (
                <small className="text-danger ms-2 fw-700">status is required</small>
              ) : toggles.isStatusConfirmation && processType !== "CTPAT" ? (
                <small className="ms-2 fst-italic">Press enter to add new option</small>
              ) : null}
            </div>
          </div>
        }
          {processType === "Light" && 
          <>
          <div className={`col-md-6`}>
            <ToggleSwitch 
              label="Require Reflector Status Confirmation"
              labelStyle="ms-2 fw-600"
              checked={toggles.reflectorRequired}
              onChange={(value:any) => {handleToggleChange("reflectorRequired", value)}}/>
            <CreatableSelect
              isMulti
              options={[]}
              name="reflectorStatus"
              value={reflectorStatus}
              onChange={(selected:any) => setReflectorStatus(selected)}
              placeholder={"Enter Reflector Status..."}
              className="basic-multi-select "
              classNamePrefix="select"
              isDisabled={!toggles.reflectorRequired}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  minHeight: "42px",
                }),
              }}
            />
            {toggles.reflectorRequired && reflectorStatus.length === 0 ? (
              <small className="text-danger ms-2 fw-700">Reflector status is required</small>
            ) : null}
            </div>
            <div className={`col-md-6`} style={{paddingTop: "35px"}}>
              <ToggleSwitch 
                label="Capture Reflector count"
                labelStyle="ms-2 fw-600"
                checked={toggles.reflectorCountRequired}
                onChange={(value :any) => handleToggleChange("reflectorCountRequired", value)}
                />
            </div></>}
        </div>)}
    </div>
  )
}
const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const visibleCount = 3;
  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(",  ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
};
export default ProcessTypeSpecific